import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "lead"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = ["readonly"]
const _hoisted_5 = { class: "error" }
const _hoisted_6 = {
  key: 1,
  class: "form-group"
}
const _hoisted_7 = ["readonly"]
const _hoisted_8 = {
  key: 2,
  class: "form-group"
}
const _hoisted_9 = ["readonly", "disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }

import { computed, toRef } from 'vue'

    import type { AlternativeEditorReadModel } from "@Alternatives/Alternatives/Domain/readmodels"
    import type { ValidationError } from "@common/types"

    import TextInputSingleValue from "@Alternatives/Alternatives/Components/FormFields/TextInputSingleValue.vue"
    import TextInputMultiValue from "@Alternatives/Alternatives/Components/FormFields/TextInputMultiValue.vue"
    import TextListSingleValue from "@Alternatives/Alternatives/Components/FormFields/TextListSingleValue.vue"
    import TextListMultiValue from "@Alternatives/Alternatives/Components/FormFields/TextListMultiValue.vue"
    import TextMultilineSingleValue from "@Alternatives/Alternatives/Components/FormFields/TextMultilineSingleValue.vue"

    import NumberInputSingleValue from "@Alternatives/Alternatives/Components/FormFields/NumberInputSingleValue.vue"
    import NumberInputMultiValue from "@Alternatives/Alternatives/Components/FormFields/NumberInputMultiValue.vue"
    import NumberListSingleValue from "@Alternatives/Alternatives/Components/FormFields/NumberListSingleValue.vue"
    import NumberListMultiValue from "@Alternatives/Alternatives/Components/FormFields/NumberListMultiValue.vue"
    import NumberCalculatedSingleValue from "@Alternatives/Alternatives/Components/FormFields/NumberCalculatedSingleValue.vue"

    import EmailInputSingleValue from "@Alternatives/Alternatives/Components/FormFields/EmailInputSingleValue.vue"
    import EmailInputMultiValue from "@Alternatives/Alternatives/Components/FormFields/EmailInputMultiValue.vue"
    import EmailListSingleValue from "@Alternatives/Alternatives/Components/FormFields/EmailListSingleValue.vue"
    import EmailListMultiValue from "@Alternatives/Alternatives/Components/FormFields/EmailListMultiValue.vue"

    import DateInputSingleValue from "@Alternatives/Alternatives/Components/FormFields/DateInputSingleValue.vue"
    import DateInputMultiValue from "@Alternatives/Alternatives/Components/FormFields/DateInputMultiValue.vue"
    import DateListSingleValue from "@Alternatives/Alternatives/Components/FormFields/DateListSingleValue.vue"
    import DateListMultiValue from "@Alternatives/Alternatives/Components/FormFields/DateListMultiValue.vue"

    import { AlternativeAttributeValueDTO } from "@Alternatives/Model"

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AlternativeEditor',
  props: {
    propRm: {},
    propFormId: {},
    propErrors: {}
  },
  emits: ["form-submit"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const rm = toRef(props, 'propRm')
    const errors = toRef(props, 'propErrors')
    const formId = toRef(props, 'propFormId')

    /* ---------------- computed ---------------- */

    const nameError = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith("Alternative:") &&
            e.ErrorCode.startsWith("Name.")
        )?.Error
    )

    /* ---------------- actions ---------------- */

    function formSubmit()
    {
        const name = rm.value.AlternativeName
        const description = rm.value.AlternativeDescription
        const statusId = rm.value.AlternativeStatusId

        const attributeValues = rm.value.Sections
            .flatMap(s => s.Attributes)
            .flatMap(attr =>
            {
                if (attr.Value != null)
                {
                    const v = new AlternativeAttributeValueDTO()
                    v.AttributeId = attr.Id
                    v.Value = attr.Value
                    return [v]
                }

                return attr.Values
                    .filter(v => v != null)
                    .map(v =>
                    {
                        const av = new AlternativeAttributeValueDTO()
                        av.AttributeId = attr.Id
                        av.Value = v
                        return av
                    })
            })

        emit('form-submit', name, description, statusId, attributeValues)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      onSubmit: _withModifiers(formSubmit, ["prevent"]),
      id: formId.value
    }, [
      (rm.value.FormBlurb)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(rm.value.FormBlurb), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"color":"red"} }, "*", -1 /* CACHED */)),
          _createTextVNode(" " + _toDisplayString(rm.value.AlternativeLabel) + " Name", 1 /* TEXT */)
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rm.value.AlternativeName) = $event)),
          class: "form-control",
          readonly: rm.value.IsNameReadonly,
          required: ""
        }, null, 8 /* PROPS */, _hoisted_4), [
          [
            _vModelText,
            rm.value.AlternativeName,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(nameError.value), 1 /* TEXT */)
      ]),
      (rm.value.IsDescriptionVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[4] || (_cache[4] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rm.value.AlternativeDescription) = $event)),
              class: "form-control",
              readonly: rm.value.IsDescriptionReadonly
            }, null, 8 /* PROPS */, _hoisted_7), [
              [
                _vModelText,
                rm.value.AlternativeDescription,
                void 0,
                { trim: true }
              ]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (rm.value.IsStatusVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("label", null, "Status:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rm.value.AlternativeStatusId) = $event)),
              readonly: rm.value.IsStatusReadonly,
              disabled: rm.value.IsStatusReadonly
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Statuses, (s) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: s.Id
                }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_10))
              }), 256 /* UNKEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_9), [
              [_vModelSelect, rm.value.AlternativeStatusId]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rm.value.Sections, (s) => {
        return (_openBlock(), _createElementBlock("div", {
          key: s.Name
        }, [
          (s.Name)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_11, [
                _createElementVNode("a", {
                  class: "text-primary",
                  onClick: ($event: any) => (s.IsExpanded = !s.IsExpanded)
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa fa-angle-right", {'fa-angle-down': s.Expanded}])
                  }, null, 2 /* CLASS */),
                  _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_12)
              ]))
            : _createCommentVNode("v-if", true),
          (s.IsExpanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Attributes, (f) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: f.Id
                  }, [
                    (f.FieldType === 'DateInputSingleValue')
                      ? (_openBlock(), _createBlock(DateInputSingleValue, {
                          key: 0,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'DateInputMultiValue')
                      ? (_openBlock(), _createBlock(DateInputMultiValue, {
                          key: 1,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'DateListSingleValue')
                      ? (_openBlock(), _createBlock(DateListSingleValue, {
                          key: 2,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'DateListMultiValue')
                      ? (_openBlock(), _createBlock(DateListMultiValue, {
                          key: 3,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'EmailInputSingleValue')
                      ? (_openBlock(), _createBlock(EmailInputSingleValue, {
                          key: 4,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'EmailInputMultiValue')
                      ? (_openBlock(), _createBlock(EmailInputMultiValue, {
                          key: 5,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'EmailListSingleValue')
                      ? (_openBlock(), _createBlock(EmailListSingleValue, {
                          key: 6,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'EmailListMultiValue')
                      ? (_openBlock(), _createBlock(EmailListMultiValue, {
                          key: 7,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'NumberInputSingleValue')
                      ? (_openBlock(), _createBlock(NumberInputSingleValue, {
                          key: 8,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'NumberInputMultiValue')
                      ? (_openBlock(), _createBlock(NumberInputMultiValue, {
                          key: 9,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'NumberListSingleValue')
                      ? (_openBlock(), _createBlock(NumberListSingleValue, {
                          key: 10,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'NumberListMultiValue')
                      ? (_openBlock(), _createBlock(NumberListMultiValue, {
                          key: 11,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'NumberCalculatedSingleValue')
                      ? (_openBlock(), _createBlock(NumberCalculatedSingleValue, {
                          key: 12,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'TextInputSingleValue')
                      ? (_openBlock(), _createBlock(TextInputSingleValue, {
                          key: 13,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'TextInputMultiValue')
                      ? (_openBlock(), _createBlock(TextInputMultiValue, {
                          key: 14,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'TextListSingleValue')
                      ? (_openBlock(), _createBlock(TextListSingleValue, {
                          key: 15,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'TextListMultiValue')
                      ? (_openBlock(), _createBlock(TextListMultiValue, {
                          key: 16,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true),
                    (f.FieldType === 'TextMultilineSingleValue')
                      ? (_openBlock(), _createBlock(TextMultilineSingleValue, {
                          key: 17,
                          propF: f,
                          propErrors: errors.value
                        }, null, 8 /* PROPS */, ["propF", "propErrors"]))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
  ]))
}
}

})